
import { customClient } from "../../../../../openapi/mutator/custom-client"

export const checkSEB = async() => {
    return customClient({
        url:'/seb/isSEB',
        method:'GET',     
    })
}
